export const isAbortError = (e: unknown): boolean =>
  (e as any)?.name === 'AbortError';
